import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ApiError, AuthService, ConfigService, MessageService, notCloseMessageOptions, ButtonLoader } from '../../../../../core';
import { isModoCentralCompraCadastro } from '../../../../../models/modo-central-compra';
import { ConfigEmpresa } from '../../../../configuracoes/app/empresa';
import { PessoaTipo, pessoaCentralCompras, pessoaFisica, pessoaJuridica } from '../../../tipo';
import { Cliente } from '../../cliente';
import { ClienteIntegracaoEmpresasImportHttpService } from '../../integracoes/empresas/services';
import { ClientePreInsert } from './cliente-pre-insert';
import { OrigemSelectComponent } from '../../../../common/origens/components/select';
import { ClienteValidacoesHttpService } from '../../validacoes';
import { CampanhaSelectComponent } from '../../../../campanhas/campanhas/components/select';
import { CampanhaSelect, mapToCampanha } from '../../../../campanhas/campanhas/components/select/campanha-select';
import { CanalMidiaSocialSelectComponent } from '../../../../common/canal-midia-social/components/select';
import { CanalVendaSelectComponent } from '../../../../common/canais-venda/components/select';
import { NgForm } from '@angular/forms';

interface Config {
    podeCadastrarClienteExterior: boolean;
}

@Component({
    selector: 'sgt-cliente-pre-insert-form',
    templateUrl: 'cliente-pre-insert-form.component.html',
    styleUrls: ['./cliente-pre-insert-form.component.less']
})
export class ClientePreInsertFormComponent implements OnInit {
    config: Config;
    configEmpresa: ConfigEmpresa;
    entity: ClientePreInsert;
    tipos: PessoaTipo[];

    // Permissões do usuários
    usuarioPodeSalvarCnpjCpfInvalido: boolean; // Se o usuário pode salvar o CNPJ/CPF inválido
    ignorarCnpjCpfInvalido = false; // Se deve ignorar o erro de CNPJ/CPF inválido


    /** Se deve exibir o campo da origem */
    @Input() isShowOrigem = true;

    @ViewChild('form') form: NgForm;
    @ViewChild('origemSelect') origemSelect: OrigemSelectComponent;
    @ViewChild('campanhaOrigemSelect') campanhaOrigemSelect: CampanhaSelectComponent;
    @ViewChild('canalMidiaSocialSelect') canalMidiaSocialSelect: CanalMidiaSocialSelectComponent;
    @ViewChild('canalVendaOrigemSelect') canalVendaOrigemSelect: CanalVendaSelectComponent;
    @ViewChild('cnpjCpfInput') cnpjCpfInput: ElementRef;
    @ViewChild('btnConfirm') btnConfirm: ElementRef;

    @Output() confirm = new EventEmitter<ClientePreInsert>();

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private configService: ConfigService,
                private messageService: MessageService,
                private clienteValidacoesHttpService: ClienteValidacoesHttpService,
                private clienteIntegracaoEmpresasImportHttpService: ClienteIntegracaoEmpresasImportHttpService) { }

    ngOnInit(): void {
        this.configEmpresa = this.configService.getEmpresa();
        // Permissões do usuários
        this.usuarioPodeSalvarCnpjCpfInvalido = this.authService.podeSalvarCnpjCpfInvalido();

        this.entity = new ClientePreInsert();

        this.setConfig();
        this.createTipos();
        setTimeout(() => this.setFocusOrigem(), 300);
    }

    private setConfig() {
        this.config = {
            podeCadastrarClienteExterior: this.configEmpresa?.exportadora && this.authService.podeCadastrarClienteExterior()
        }
    }

    /** Cria os tipos de pessoas */
    private createTipos() {
        this.tipos = [];
        // Física
        this.tipos.push(pessoaFisica);
        // Jurídica
        this.tipos.push(pessoaJuridica);
        // Cental de Compras
        if (isModoCentralCompraCadastro(this.configEmpresa.modoCentralCompra)) {
            this.tipos.push(pessoaCentralCompras);
        }
    }

    /** Ao alterar a origem */
    onChangeOrigem(origem: number) {
        this.entity.origem = origem;

        setTimeout(() => {
            if (this.entity.isOrigemPossuiCanalVenda()) {
                this.setFocusCanalVendaOrigem();
            } else if (this.entity.isOrigemCampanha()) {
                this.setFocusCampanhaOrigem();
            } else if (this.entity.isOrigemMidiaSocial()) {
                this.setFocusCanalMidiaSocial();
            } else {
                if (this.entity.isTipoPessoaFisicaOuJuridica()) {
                    this.setFocusCnpjCPF();
                }
            }
        }, 100);
    }

    /** Ao alterar o tipo da pessoa */
    onChangeTipoPessoa(tipoPessoa: number) {
        this.entity.tipoPessoa = tipoPessoa;
        if (this.entity.isTipoPessoaFisicaOuJuridica()) {
            setTimeout(() => this.setFocusCnpjCPF(), 0);
        }
    }

    /** Seta foco no select da origem */
    private setFocusOrigem() {
        this.origemSelect?.setFocus();
    }

    /** Seta foco no select da campanha de origem */
    private setFocusCampanhaOrigem() {
        this.campanhaOrigemSelect?.setFocus();
    }

    /** Seta foco no select do canal da mídia social */
    private setFocusCanalMidiaSocial() {
        this.canalMidiaSocialSelect?.setFocus();
    }

    /** Seta foco no select do canal de venda de origem */
    private setFocusCanalVendaOrigem() {
        this.canalVendaOrigemSelect?.setFocus();
    }

    /** Seta foco no input do CNPJ/CPF */
    setFocusCnpjCPF() {
        jQuery(this.cnpjCpfInput?.nativeElement).trigger('focus');
    }

    /** Verifica se o CNPJ/CPF é obrigatório */
    isCnpjCpfRequired(): boolean {
          // Somente quando for uma pessoa do tipo Física ou Juridica que não seja do exterior
        return this.entity?.isTipoPessoaFisicaOuJuridica() && !this.entity.exterior;
    }

    /** Verifica se deve validar o CNPJ/CPF */
    mustValidateCnpjCpf(): boolean {
        if (!this.entity) {
            return true;
        }

        // Se o usuário poder salvar com o CNPJ/CPF e estiver selecionado para ignorar o erro de validação, então não deve validar
        if (this.usuarioPodeSalvarCnpjCpfInvalido && this.ignorarCnpjCpfInvalido) {
            return false;
        }

        // Se não for uma pessoa Física ou Juridica então não deve validar
        if (!this.entity?.isTipoPessoaFisicaOuJuridica()) {
            return false;
        }

        // Se for do exterior, então não deve validar
        if (this.entity.exterior) {
            return false;
        }

        return true;
    }

    /** Ao alterar a campanha de origem do cliente */
    onChangeCampanhaOrigem(campanhaOrigem: CampanhaSelect) {
        this.entity.campanhaOrigem = mapToCampanha(campanhaOrigem);
    }

    /** Realiza a validação de cadastro já existe do cliente e pessoa através do CNPJ/CPF informado */
    private validarCnpjCpfCadastrado(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if (!this.entity) {
                resolve(false);
                return;
            }
            // Se for um cliente do exterior, então ignoramos a validação pois o mesmo não possui um CNPJ
            if (this.entity.exterior) {
                resolve(true);
                return;
            }
            // Se for uma central de compras não precisa validar
            if (this.entity.isTipoPessoaCentralCompras()) {
                resolve(true);
                return;
            }

            this.clienteValidacoesHttpService.getClienteJaCadastrado(null, this.entity.cnpjCpf, this.authService.getIdRepresentante(), false)
                .subscribe(
                    validacao => {
                        // Verificando se o CNPJ Matriz (parte até a "/") já esta cadastrado
                        if (validacao.cnpjMatrizJaCadastrado) {
                            this.messageService.info('Não é possível cadastrar o cliente por que já existe um cliente cadastrado com o CNPJ da Matriz igual ao informado. Por favor entre em contato com o comercial para mais informações', 'Informação', notCloseMessageOptions);
                            resolve(false);
                            return;
                        }

                        // Verificando se o cliente já está cadastrado para o representante ou para a empresa
                        if (validacao.jaCadastrado) {
                            alert('Já existe um cliente cadastrado com este CNPJ/CPF informado. O seus dados serão carregados');
                            // Navegando para o cadastrado do cliente para entrar em modo de edição
                            this.router.navigate(['../', validacao.id], {relativeTo: this.activatedRoute});
                            resolve(false);
                            return;
                        }

                        // Sem permissão para cadastrar clientes secundários
                        if (validacao.clienteSecundarioNaoPermitido) {
                            this.messageService.info('O CNPJ/CPF informado já está cadastrado para outro cliente e não é permitido cadastrar clientes secundários. Entre em contato com o comercial ou o suporte para mais informações', 'Informação', notCloseMessageOptions);
                            resolve(false);
                            return;
                        }

                        // Verificando se a pessoa já está cadastrada
                        if (validacao.pessoaJaCadastrada) {
                            this.messageService.warning('Já existe um cadastrado com este CNPJ/CPF informado. Consulte o cadastro deste CNPJ/CPF para poder editá-lo', 'Atenção');
                            resolve(false);
                            return;
                        }

                        resolve(true);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Ocorreu um erro ao verificar se o já existe um cliente com o CNPJ/CPF cadastrado', error);
                        resolve(false);
                    }
                );
        });
    }

    /** Verificando se os dados de pré-insert está válidos */
    private isValid(): Promise<boolean> {
        return new Promise<boolean>(async (resolve) => {
            // Origem não selecionada
            if (!this.origemSelect.isValid) {
                this.messageService.warning('Selecione a origem deste prospect e tente novamente', 'Origem do prospect não selecionada', notCloseMessageOptions);
                this.setFocusOrigem();
                resolve(false);
                return;
            }

            // Campanha
            if (this.entity.isOrigemCampanha()) {
                if (!this.entity.idCampanhaOrigem) {
                    this.messageService.warning('Selecione a campanha de origem deste prospect e tente novamente', 'Campanha de origem do prospect não selecionada', notCloseMessageOptions);
                    this.setFocusCampanhaOrigem();
                    resolve(false);
                    return;
                }
            }

            // Canal da mídia social
            if (this.entity.isOrigemMidiaSocial()) {
                if (!this.canalMidiaSocialSelect.isValid) {
                    this.messageService.warning('Selecione o canal da mídia social que gerou este prospect e tente novamente', 'Canal da mídia social não selecionado', notCloseMessageOptions);
                    this.setFocusCanalMidiaSocial();
                    resolve(false);
                    return;
                }
            }

            // Canal de venda de origem
            if (this.entity.isOrigemPossuiCanalVenda() && !this.canalVendaOrigemSelect?.isValid) {
                this.messageService.warning('Selecione o canal de venda de origem deste prospect e tente novamente', 'Canal de venda de origem não selecionado', notCloseMessageOptions);
                this.setFocusCanalVendaOrigem();
                resolve(false);
                return;
            }

            // Pessoa Física
            if (this.entity.isTipoPessoaFisica()) {
                if (this.isCnpjCpfRequired() && !this.entity.cnpjCpf) {
                    this.messageService.warning('Informe o CPF do prospect e tente novamente', 'CPF não informado', notCloseMessageOptions);
                    this.setFocusCnpjCPF();
                    resolve(false);
                    return;
                }
            }

            // Pessoa Jurídica
            if (this.entity.isTipoPessoaJuridica()) {
                if (this.isCnpjCpfRequired() && !this.entity.cnpjCpf) {
                    this.messageService.warning('Informe o CNPJ do prospect e tente novamente', 'CNPJ não informado', notCloseMessageOptions);
                    this.setFocusCnpjCPF();
                    resolve(false);
                    return;
                }
            }

            // Form inválid
            if (this.form.invalid) {
                this.messageService.warning('Verifique os dados informados e tente novamente', 'Dados inválidos', notCloseMessageOptions);
                resolve(false);
                return;
            }

            // Validando cadastro
            const isValid = await this.validarCnpjCpfCadastrado();
            if (!isValid) {
                resolve(false);
                return;
            }

            resolve(true);
        });
    }

    /** Realiza a consulta do CNPJ de uma empresas */
    private consultarCnpj(): Promise<Cliente> {
        return new Promise<Cliente>((resolve, reject) => {
            if (this.isCnpjCpfRequired() && (!this.entity.cnpjCpf || this.entity.cnpjCpf === '')) {
                this.messageService.warning('Informe um CNPJ válido para poder consultá-lo', 'Atenção', notCloseMessageOptions);
                this.setFocusCnpjCPF();
                reject();
                return;
            } else if (!this.entity.cnpjCpf) {
                resolve(null);
                return;
            }

            const btn = new ButtonLoader(this.btnConfirm.nativeElement);
            btn.loading('Consultando CNPJ')
            this.clienteIntegracaoEmpresasImportHttpService.consultaCNPJ(this.entity.cnpjCpf)
                .pipe(
                    take(1)
                )
                .subscribe(
                    response => {
                        resolve(response);
                        btn.reset();
                    },
                    (error: ApiError) => {
                        btn.reset();

                        // Nenhum CNPJ encontrado na base de dados (Pode ser por cliente baixado mas por cliente novo que ainda não foi inserido na base de CNPJ da Receita Federal)
                        if (error.status == 404) {
                            this.messageService.warning(error.message, error.cause, notCloseMessageOptions);
                            resolve(null);
                            return;
                        }

                        this.messageService.error(error.message, error.cause, error);
                        reject();
                    }
                );
        });
    }

    /** Ao confirmar o pré-insert */
    async confirmClick() {
        try {
            // Validando cadastro
            const isValid = await this.isValid();
            if (!isValid) {
                return;
            }

            if (this.entity.isTipoPessoaJuridica() && !this.entity.exterior) { // Pessoa jurídica consulta o CNPJ da empresa
                this.entity.clientePessoaJuridica = await this.consultarCnpj();
            } else {
                this.entity.clientePessoaJuridica = null;
            }

            this.confirm.emit(this.entity);
        } catch (error) {
            //
        }
    }
}
